import React, { FunctionComponent, MouseEventHandler } from 'react';
import classNames from 'classnames';
import styles from './boards-menu.less';
import { useFocusRing } from '@trello/a11y';
import { TestId } from '@trello/test-ids';

interface BoardsMenuButtonProps {
  onClick: MouseEventHandler;
  className?: string;
  testId?: TestId;
}

export const BoardsMenuButton: FunctionComponent<BoardsMenuButtonProps> = ({
  onClick,
  className,
  testId,
  children,
}) => {
  const [hasFocusRing, mouseEvents] = useFocusRing();

  return (
    <button
      onClick={onClick}
      className={classNames(
        styles.menuButton,
        hasFocusRing && styles.menuButtonFocusRing,
        className,
      )}
      data-test-id={testId}
      {...mouseEvents}
    >
      {children}
    </button>
  );
};
